import React from 'react';
import { Button } from './ui/button';
import { Calendar, Star, Users, Clock } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="pt-32 pb-24 bg-gradient-to-br from-slate-100 via-emerald-50 to-green-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-10">
            <div className="space-y-8">
              <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 text-emerald-900 leading-tight">
                AI that never lets your patients hit voicemail.
                
              </h1>
              <p className="text-xl text-slate-700 leading-relaxed max-w-2xl">
                Comprehensive patient management solution— resolving 99% of patient inquiries, scheduling appointments,
                reducing no-shows, and managing aftercare follow-ups across voice and text
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white px-8 py-4 text-lg font-medium shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
                onClick={() => {
                  const demoSection = document.getElementById('demo');
                  if (demoSection) {
                    demoSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Show Me How
              </Button>
            </div>

            <div className="flex items-center space-x-8 pt-8">
              <div className="flex items-center space-x-2">
                <Calendar className="w-5 h-5 text-emerald-600" />
                <span className="text-sm font-medium text-slate-700">Treatment Scheduling</span>
              </div>
              <div className="flex items-center space-x-2">
                <Star className="w-5 h-5 text-emerald-600" />
                <span className="text-sm font-medium text-slate-700">Pain Relief Follow-ups</span>
              </div>
              <div className="flex items-center space-x-2">
                <Users className="w-5 h-5 text-emerald-600" />
                <span className="text-sm font-medium text-slate-700">Multi-Location</span>
              </div>
            </div>
          </div>

          <div className="relative bg-gradient-to-br from-slate-50 via-gray-50 to-gray-100 rounded-2xl p-6">
            <div className="relative bg-gradient-to-br from-white via-slate-50 to-gray-50 rounded-xl shadow-xl p-8 border border-slate-200/50 backdrop-blur-sm">
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900">AI Assistant Dashboard</h3>
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                    <span className="text-xs text-gray-500">Online</span>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg p-4 border border-gray-200/50">
                    <div className="flex items-start space-x-3">
                      <Calendar className="w-5 h-5 text-gray-900 mt-0.5" />
                      <div>
                        <p className="text-sm font-medium text-gray-900">Appointment Scheduled</p>
                        <p className="text-xs text-gray-600">Sarah M. - Spinal Adjustment - Tomorrow 2:00 PM</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-green-50 to-emerald-100 rounded-lg p-4 border border-green-200/50">
                    <div className="flex items-start space-x-3">
                      <Star className="w-5 h-5 text-green-600 mt-0.5" />
                      <div>
                        <p className="text-sm font-medium text-gray-900">Review Request Sent</p>
                        <p className="text-xs text-gray-600">Mike T. - Lower Back Treatment Complete</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-purple-50 to-violet-100 rounded-lg p-4 border border-purple-200/50">
                    <div className="flex items-start space-x-3">
                      <Clock className="w-5 h-5 text-purple-600 mt-0.5" />
                      <div>
                        <p className="text-sm font-medium text-gray-900">Treatment Follow-up</p>
                        <p className="text-xs text-gray-600">Neck pain progress check sent to 8 patients</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-24 pt-16 border-t border-gray-100">
          <p className="text-center text-sm text-gray-500 mb-12">Trusted by healthcare practices nationwide</p>
          <div className="overflow-x-auto">
            <div className="flex justify-center md:justify-center items-center space-x-4 md:space-x-16 opacity-50 min-w-max md:min-w-0">
              <div className="text-lg font-medium text-gray-400 whitespace-nowrap">Wellness Family Care</div>
              <div className="text-lg font-medium text-gray-400 whitespace-nowrap">Comprehensive Care Clinic</div>
              <div className="text-lg font-medium text-gray-400 whitespace-nowrap">Primary Health Center</div>
              <div className="text-lg font-medium text-gray-400 whitespace-nowrap">Advanced Medical Group</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};